import { type SVGProps } from 'react'

/**
 * Heart inside a circle — companion to lucide's `CircleUser`/`Target` so the
 * three indicator icons (skills/values/personality) all share a circular
 * outline at small sizes.
 */
export function HeartCircleIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="24"
      height="24"
      strokeWidth="2"
      {...props}
      viewBox="0 0 24 24"
    >
      <circle cx="12" cy="12" r="10" />
      <g transform="translate(6 6) scale(0.5)" strokeWidth="4">
        <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.29 1.51 4.04 3 5.5l7 7Z" />
      </g>
    </svg>
  )
}

export function IconDiscoverYourProfile(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" {...props} viewBox="0 0 24 24">
      <path
        fill="rgb(var(--color-primary))"
        d="M12 14c-4.4 0-8 1.8-8 4v2h6v-1.9l4-4c-.7-.1-1.3-.1-2-.1m0-10C9.8 4 8 5.8 8 8s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4"
      />
      <path
        fill="rgb(var(--color-primary) / 0.5)"
        d="m21.7 13.4-1 1-2.1-2.1 1-1c.2-.2.6-.2.8 0l1.3 1.3c.2.3.2.6 0 .8M12 19l6.1-6 2 2-6 6.1H12z"
      />
    </svg>
  )
}

export function IconDescribeYourJob(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" {...props} viewBox="0 0 24 24">
      <path
        fill="rgb(var(--color-primary))"
        d="M14 2c1.1 0 2 .9 2 2v2h4c1.1 0 2 .9 2 2L10.9 19v2H4c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2h4V4c0-1.1.9-2 2-2zm0 4V4h-4v2z"
      />
      <path
        fill="rgb(var(--color-primary) / 0.5)"
        d="M20.6 12c-.1 0-.3.1-.4.2l-1 1 2.1 2.1 1-1c.2-.2.2-.6 0-.8L21 12.2c-.1-.1-.3-.2-.4-.2m-2 1.8-6 6v2.1h2l6.1-6.1z"
      />
    </svg>
  )
}

export function IconInviteYourApplicants(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" {...props} viewBox="0 0 24 24">
      <path fill="rgb(var(--color-primary))" d="M21 17V7l-9-5-9 5v10zm0 2H3v2h18zm-9-7L5.5 8.5 12 5l6.5 3.5z" />
      <path
        fill="rgb(var(--color-primary) / 0.5)"
        d="M20.6 12c-.1 0-.3.1-.4.2l-1 1 2.1 2.1 1-1c.2-.2.2-.6 0-.8L21 12.2c-.1-.1-.3-.2-.4-.2m-2 1.8-6 6v2.1h2l6.1-6.1z"
      />
    </svg>
  )
}

export function IconCompareResults(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" {...props} viewBox="0 0 24 24">
      <path
        fill="rgb(var(--color-primary))"
        d="m16 6 2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"
      />
    </svg>
  )
}

export function IconAnalyzeYourTeams(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" {...props} viewBox="0 0 24 24">
      <path
        fill="rgb(var(--color-primary))"
        d="M12 5.5A3.5 3.5 0 0 1 15.5 9a3.5 3.5 0 0 1-3.5 3.5A3.5 3.5 0 0 1 8.5 9 3.5 3.5 0 0 1 12 5.5M5 8c.56 0 1.08.15 1.53.42-.15 1.43.27 2.85 1.13 3.96C7.16 13.34 6.16 14 5 14a3 3 0 0 1-3-3 3 3 0 0 1 3-3m14 0a3 3 0 0 1 3 3 3 3 0 0 1-3 3c-1.16 0-2.16-.66-2.66-1.62a5.54 5.54 0 0 0 1.13-3.96c.45-.27.97-.42 1.53-.42M5.5 18.25c0-2.07 2.91-3.75 6.5-3.75s6.5 1.68 6.5 3.75V20h-13zM0 20v-1.5c0-1.39 1.89-2.56 4.45-2.9-.59.68-.95 1.62-.95 2.65V20zm24 0h-3.5v-1.75c0-1.03-.36-1.97-.95-2.65 2.56.34 4.45 1.51 4.45 2.9z"
      />
    </svg>
  )
}

export function IconAnalyzeMarket(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" {...props} viewBox="0 0 24 24">
      <path
        fill="rgb(var(--color-primary))"
        d="M17.9 17.39c-.26-.8-1.01-1.39-1.9-1.39h-1v-3a1 1 0 0 0-1-1H8v-2h2a1 1 0 0 0 1-1V7h2a2 2 0 0 0 2-2v-.41a7.984 7.984 0 0 1 2.9 12.8M11 19.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.22.21-1.79L9 15v1a2 2 0 0 0 2 2m1-16A10 10 0 0 0 2 12a10 10 0 0 0 10 10 10 10 0 0 0 10-10A10 10 0 0 0 12 2"
      />
    </svg>
  )
}

export function IconIntegrateOurAPI(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" {...props} viewBox="0 0 24 24">
      <path
        fill="rgb(var(--color-primary))"
        d="m14.6 16.6 4.6-4.6-4.6-4.6L16 6l6 6-6 6zm-5.2 0L4.8 12l4.6-4.6L8 6l-6 6 6 6z"
      />
    </svg>
  )
}

/**
 * Radar segment icons for board indicator categories.
 * Based on the radar chart design with concentric rings:
 * - Competencies: outer ring (18 items)
 * - Vectors: middle ring (6 items)
 * - Dimensions: inner ring (3 items)
 */

/** Competencies - outer ring highlighted */
export function IconRadarCompetencies(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      {/* Inner filled circle (dimensions core) */}
      <circle cx="12" cy="12" r="2.5" fill="currentColor" opacity="0.15" />
      {/* Middle ring */}
      <circle cx="12" cy="12" r="5.5" stroke="currentColor" strokeWidth="2" opacity="0.2" />
      {/* Outer ring - highlighted */}
      <circle cx="12" cy="12" r="9.5" stroke="currentColor" strokeWidth="3" />
      {/* Division lines (3 dimensions) */}
      <line x1="12" y1="12" x2="12" y2="2" stroke="currentColor" strokeWidth="1" opacity="0.3" />
      <line x1="12" y1="12" x2="20.66" y2="17" stroke="currentColor" strokeWidth="1" opacity="0.3" />
      <line x1="12" y1="12" x2="3.34" y2="17" stroke="currentColor" strokeWidth="1" opacity="0.3" />
    </svg>
  )
}

/** Vectors - middle ring highlighted */
export function IconRadarVectors(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      {/* Inner filled circle (dimensions core) */}
      <circle cx="12" cy="12" r="2.5" fill="currentColor" opacity="0.15" />
      {/* Middle ring - highlighted */}
      <circle cx="12" cy="12" r="5.5" stroke="currentColor" strokeWidth="3" />
      {/* Outer ring */}
      <circle cx="12" cy="12" r="9.5" stroke="currentColor" strokeWidth="2" opacity="0.2" />
      {/* Division lines (3 dimensions) */}
      <line x1="12" y1="12" x2="12" y2="2" stroke="currentColor" strokeWidth="1" opacity="0.3" />
      <line x1="12" y1="12" x2="20.66" y2="17" stroke="currentColor" strokeWidth="1" opacity="0.3" />
      <line x1="12" y1="12" x2="3.34" y2="17" stroke="currentColor" strokeWidth="1" opacity="0.3" />
    </svg>
  )
}

/** Dimensions - inner ring highlighted */
export function IconRadarDimensions(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      {/* Inner filled circle (dimensions core) - highlighted */}
      <circle cx="12" cy="12" r="3.5" fill="currentColor" opacity="0.9" />
      {/* Middle ring */}
      <circle cx="12" cy="12" r="5.5" stroke="currentColor" strokeWidth="2" opacity="0.2" />
      {/* Outer ring */}
      <circle cx="12" cy="12" r="9.5" stroke="currentColor" strokeWidth="2" opacity="0.2" />
      {/* Division lines (3 dimensions) */}
      <line x1="12" y1="12" x2="12" y2="2" stroke="currentColor" strokeWidth="1" opacity="0.3" />
      <line x1="12" y1="12" x2="20.66" y2="17" stroke="currentColor" strokeWidth="1" opacity="0.3" />
      <line x1="12" y1="12" x2="3.34" y2="17" stroke="currentColor" strokeWidth="1" opacity="0.3" />
    </svg>
  )
}
